// removed by extract-text-webpack-plugin
module.exports = {"searchBar":"common_searchBar_2tfwV","large":"common_large_PFfKc","wrap":"common_wrap_VzH7d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/regulatoryStatistical/index/common/common.scss
// module id = 105
// module chunks = 0